module.exports = __webpack_public_path__ + "static/media/1_A1_26.bc19738f.png";